/* eslint-disable no-param-reassign */
const railsParameters = (parameters, name, value) => {
  if (name === 'add_rails_left_right') {
    if (value === '1') {
      parameters.rails_left = '0.5';
      parameters.rails_right = '0.5';
    } else {
      parameters.rails_left = '';
      parameters.rails_right = '';
    }
  } else if (name === 'add_rails_top_bottom') {
    if (value === '1') {
      parameters.rails_top = '0.5';
      parameters.rails_bottom = '0.5';
    } else {
      parameters.rails_top = '';
      parameters.rails_bottom = '';
    }
  }
};

const tabRoutePanelsParameter = (parameters) => {
  parameters.has_array = '1';
  parameters.scoring = '0';
  parameters.tab_rout = '1';
  parameters.array_spacing_x = parameters.array_spacing_x_tab_rout;
  parameters.array_spacing_y = parameters.array_spacing_y_tab_rout;
};

const vScorePanelsParameter = (parameters) => {
  parameters.has_array = '1';
  parameters.scoring = '1';
  parameters.tab_rout = '0';

  parameters.array_spacing_x = parameters.array_spacing_x_vscore;
  parameters.array_spacing_y = parameters.array_spacing_y_vscore;
};

export const changeParameterByName = (parameters, name, value) => {
  switch (name) {
    case 'add_rails_left_right':
    case 'add_rails_top_bottom':
      railsParameters(parameters, name, value);
      break;
    case 'tab_route_panels':
      tabRoutePanelsParameter(parameters, name, value);
      break;
    case 'v_score_panels':
      vScorePanelsParameter(parameters, name, value);
      break;
    case 'qty1':
      parameters.quantities[0] = value;
      break;
    case 'qty2':
      parameters.quantities[1] = value;
      break;
    case 'qty3':
      parameters.quantities[2] = value;
      break;
    case 'qty4':
      parameters.quantities[3] = value;
      break;
    case 'array_spacing_x_tab_rout':
    case 'array_spacing_x_vscore':
      parameters.array_spacing_x = value;
      parameters[name] = value;
      break;
    case 'array_spacing_y_tab_rout':
    case 'array_spacing_y_vscore':
      parameters.array_spacing_y = value;
      parameters[name] = value;
      break;
    default:
      parameters[name] = value;
      break;
  }
};

export default changeParameterByName;
